var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"talents-list",attrs:{"id":"talents-list"}},[_c('div',{staticClass:"card card-custom card-stretch h-auto"},[_c('div',{staticClass:"card-body"},[_c('Tags')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }